<template>
  <div>
    <div
      class="item shadow-light rounded-xl p-2 px-3 cursor-pointer d-flex align-items-center"
      :class="{'background-white': !nightMode, 'background-black': nightMode, disabled: !target}"
      v-b-modal.save-to-list
    >
      <div class="d-flex justify-content-between align-items-center ">
        <span class="text-color2 font-size-small nowrap">
          <i class="fa fa-list mr-1"></i>
          Salvar
        </span>
      </div>
    </div>
    <SaveToListModal
      :type="type"
      :target="target"
    />
  </div>
</template>

<script>

import SaveToListModal from '@/components/lists/SaveToListModal.vue'
import { mapState } from 'vuex'

export default {
  name: 'SaveToListTag',
  props: ['target', 'type'],
  components: {
    SaveToListModal
  },
  computed: {
    ...mapState({
      nightMode: state => state.nightMode
    })
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.item {
  height: 56px;
}
</style>
